import React from 'react';
import { Button } from './Button';
export function FinalPurchaseSection() {
  return <section className="py-10 px-4 bg-brand-dark border-t border-white/5" data-id="element-49">
      <div className="max-w-xl mx-auto text-center" data-id="element-50">
        <div className="mb-6" data-id="element-51">
          <p className="text-sm font-bold text-red-500 mb-2" data-id="element-52">
            ⏰ EL PRECIO DE LANZAMIENTO CIERRA HOY.
          </p>
          <h2 className="text-lg font-black text-white mb-4" data-id="element-53">
            🏆 KIT PROFESIONAL + PROYECTOS INTEGRADORES
          </h2>
          <p className="text-sm text-gray-400 line-through mb-1" data-id="element-54">
            Precio Regular: $63.00 USD
          </p>
          <p className="text-2xl font-black text-brand-accent mb-6" data-id="element-55">
            PRECIO HOY: $19.90 USD
          </p>
        </div>

        <Button href="https://electrotecnia.impultienda.ar/checkout" className="w-full py-4 text-lg" data-id="element-56">
          👉 SÍ, QUIERO EL KIT COMPLETO AHORA
        </Button>
      </div>
    </section>;
}